export const DEFAULT_LOCATION_NAME = 'Москва';
export const EARTH_RADIUS = 6371;
export const SEARCH_RADIUS = 10;
export const USER_LOCATION = 'user-location';
export const IS_GEOLOCATION_ON = 'is_geolocation_on';

// TODO: It must be updated on each project, or the first location will be taken
export const DEFAULT_LOCATION_ID = '88';
